export default __webpack_public_path__ + "static/media/TBM-1.46383225.jpg";